/**
 * Save Load Configuration HeaderItem
 * */

import React from "react";
import SaveComponent from "../../modal/saveYourDesign/SaveComponent";
import LoadComponent from "../../modal/loadYourDesign/LoadComponent";
import useModal from "../../../hooks/core/useModal";
import Button from "../../independent/Button";

const MenuBottom = ({vehicleSelectHandler}) => {
  const { componentMount, subModalMount, closeModal, closeSubModal } = useModal();

  return (
    <div className="menu-bottom">
      <div className="contact-info">
        <h2>Contact</h2>
        <a href="mailto:oneofone@genesis.com">oneofone@genesis.com</a>
      </div>
      <Button className={"menu-save notheme"} name={"Save your Design"} block={true} confirm={true} size={"lg"}
              onClick={() => componentMount(
                <SaveComponent
                  subModalMount={subModalMount}
                  closeModal={closeModal}
                  closeSubModal={closeSubModal}
                />
              )}
      />
      <Button className={"menu-load notheme"} name={"Load your Design"} block={true} size={"lg"}
              onClick={() => componentMount(
                <LoadComponent
                  componentMount={componentMount}
                  vehicleSelectHandler={vehicleSelectHandler}
                  closeModal={closeModal}
                  subModalMount={subModalMount}
                  closeSubModal={closeSubModal}
                />)}
      />
      {/*<ModalPortal/>*/}
      {/*<SubModalPortal/>*/}
    </div>
  )
}
export default MenuBottom;
